// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Los-b","newExpiryDate":"styles_newExpiryDate__2R6Em","footer":"styles_footer__3Aipl"};